import React from "react";
import MaterialTable from "material-table";
import CircularProgress from "@material-ui/core/CircularProgress";
import { push } from "../../../router/history";

const ListPowerBi = (props) => {
  const user = JSON.parse(localStorage.getItem("@jarvis/user"));

  const dataFiltered = props.reportsData.filter(function (el) {
    return el != null;
  });

  const [state, setState] = React.useState({
    columns: [
      { title: "Descrição", field: "description" },
      {
        title: "Status",
        field: "activated",
        lookup: { true: "Ativo", false: "Desativado" },
      },
    ],
  });

  return props.isLoading ? (
    <CircularProgress />
  ) : (
    <MaterialTable
      title="Telas disponíveis"
      columns={state.columns}
      data={dataFiltered}
      actions={[
        {
          icon: "airplay",
          tooltip: "Visualizar tela",
          onClick: (event, rowData) => {
            push(`/powerbi/${rowData.report_id}`);
          },
        },
      ]}
      editable={user.group.name === "Administrador" ? {
       /* onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              if (oldData) {
                setState((prevState) => {
                  const data = [...prevState.data];
                  data[data.indexOf(oldData)] = newData;
                  return { ...prevState, data };
                });
              }
            }, 600);
          }),*/
        onRowDelete: (oldData) => 
        new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            props.onDeleteScreen(oldData)
            })
          }, 600)
      } : null}
      options={{
        actionsColumnIndex: -1,
      }}
      localization={{
        header: {
          actions: "Ações",
        },
        body: { editRow: { 
          deleteText: 
            'Deseja realmente excluir essa Tela?' 
        }, 
        emptyDataSourceMessage:
        <div style={{
         textAlign:'center',
        }}>
            Não existe tela cadastrada para seu setor
          </div> 
        }
      }}
    />
  );
};

export default ListPowerBi;
